import Details from "./Details";
import List from "./List";

export default { Details, List };
